// extracted by mini-css-extract-plugin
export var chip = "_mq-0";
export var icon = "_mq-1";
export var remove = "_mq-2";
export var removeIcon = "_mq-3";